import { createApiRequest } from "../common";
import { DeleteOrgCustomRoleRequestContent } from '@equaliq/api-model';

export const deleteOrgCustomRoleApi = async (request: DeleteOrgCustomRoleRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/orgs/roles/delete');
  return apiRequest(request);
};
